<script setup>
import {onUnmounted, onMounted, reactive, watch} from 'vue'
import {State, clone, fixShadow, getModels, getRoute} from '@/paks/vu-app'
import Board from './Board.vue'
import UUID from '@/paks/js-uuid'

const props = defineProps({
    refresh: Number,
})

const page = reactive({
    dashboard: null,
    design: null,
    options: {expand: false},
})

//  Component references
const {Dashboard} = getModels()

defineExpose({page})

watch(
    () => State.app.needs.reload,
    async (v) => {
        v && (await reload(true))
    }
)

onMounted(async () => {
    await reload(false)
})

onUnmounted(() => {
    fixShadow()
})

async function reload(force = true) {
    if (!State.auth.ready) return
    let route = getRoute()
    let view = route.meta.view
    let dashboard
    if (view.board) {
        dashboard = State.cache.dashboard
        if (view.board.fixed || !dashboard || dashboard.widgets?.length == 0) {
            let id = dashboard?.id
            dashboard = clone(view.board)
            dashboard.id = id
        } else {
            dashboard = await Dashboard.getCurrent()
        }
    } else {
        dashboard = await Dashboard.getCurrent()
    }
    if (force) {
        dashboard = await Dashboard.get({id: dashboard.id}, {refresh: true})
    }
    if (State.config.name == 'builder' && dashboard.widgets.length == 0) {
        let initial = State.cache.dashboard == null ? true : false
        if (initial) {
            createInitialWidgets(dashboard)
        }
    }
    dashboard.type = 'dashboard'
    page.design = route.query?.design ? true : false
    page.dashboard = dashboard
}

function createInitialWidgets(board) {
    if (State.app.widgetSets) {
        let set = State.app.widgetSets.find((s) => s.name == 'Default')
        if (set) {
            board.widgets = set.widgets
        }
    } else {
        board.widgets = []
    }
    board.widgets.forEach((w) => {
        w.range = w.range || {}
        w.anchor = w.anchor || {}
        w.css = w.css || []
        w.id = UUID()
    })
    page.options.expand = true
    State.app.setNeedSave(board)
}
</script>

<template>
    <Board
        v-if="page.dashboard"
        v-model="page.dashboard"
        :refresh="props.refresh"
        :design="page.design"
        :options="page.options"
        :type="'dashboard'" />
</template>
